import React from 'react'
import cx from 'classnames'
import './Typography.scss'

const Heading4 = ({ children, center, white, gray, bottomSpace, className }) => (
    <h4 className={cx('heading4', className, center ? 'text-center' : '', white ? 'heading-white' : '', gray ? 'heading-gray' : '', bottomSpace ? 'bottom-space' : '')}>{children}</h4>
)

export default Heading4



// WEBPACK FOOTER //
// /usr/src/site-blog/src/components/site/typography/Heading4.jsx